import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Util } from '../utils/utils';

@Injectable()
export class FarsiToEnglishInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Convert URL params
    let modifiedUrl = Util.convertFarsiToEnglish(req.url);

    let modifiedParams = req.params;
    req.params.keys().forEach(key => {
      const value = req.params.get(key);
      if (value) {
        modifiedParams = modifiedParams.set(key, Util.convertFarsiToEnglish(value));
      }
    });

    // Convert headers
    let modifiedHeaders = req.headers;
    req.headers.keys().forEach(key => {
      const value = req.headers.get(key);
      if (value) {
        modifiedHeaders = modifiedHeaders.set(key, Util.convertFarsiToEnglish(value));
      }
    });

    // Convert body
    let modifiedBody = req.body;

    // Only process body if it is a plain object; skip FormData
    if (modifiedBody instanceof FormData) {
      // do nothing, leave FormData intact
    } else if (typeof modifiedBody === 'string') {
      modifiedBody = Util.convertFarsiToEnglish(modifiedBody);
    } else if (modifiedBody && typeof modifiedBody === 'object') {
      modifiedBody = this.convertObject(modifiedBody);
    }

    const modifiedReq = req.clone({
      url: modifiedUrl,
      params: modifiedParams,
      headers: modifiedHeaders,
      body: modifiedBody
    });

    return next.handle(modifiedReq);
  }

  private convertObject(obj: any): any {
    if (typeof obj !== 'object' || obj === null) {
      return obj;
    }
    const newObj: any = Array.isArray(obj) ? [] : {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        newObj[key] = typeof obj[key] === 'string'
          ? Util.convertFarsiToEnglish(obj[key])
          : this.convertObject(obj[key]);
      }
    }
    return newObj;
  }
}
